import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getPreferredLanguage, updatePreferredLanguage } from './endpoints';

const languageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreferredLanguage: getPreferredLanguage(builder),
    updatePreferredLanguage: updatePreferredLanguage(builder),
  }),
});

export const { useGetPreferredLanguageQuery, useUpdatePreferredLanguageMutation } = languageApi;
